import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "twilio",
  "name": "Twilio",
  "category": "integrations",
  "description": "Send SMS and make phone calls with Twilio",
  "icon": "siTwilio",
  "iconType": "simple-icon",
  "color": "red",
  "version": "2.1.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Twilio",
    "color": "#f22f46"
  },
  "credentials": [
    {
      "name": "twilioApi",
      "required": true,
      "displayName": "Twilio API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "twilio",
    "sms",
    "phone",
    "call",
    "messaging"
  ],
  "comingSoon": true
};

export default definition;
